import { Component, OnInit ,ViewContainerRef} from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {AngularFirestore} from '@angular/fire/firestore';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../service/auth.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {
  image: File;
  imgurl3:any;
  id: any;
  downloadURL: Observable<string>;
  FOLDER: any = 'partner/'
  partnersForm:FormGroup;
  loading:boolean=false;
  load:boolean=false;
  constructor(private form:FormBuilder,private router:Router,private afs:AngularFirestore,private auth: AuthService, public toastr: ToastsManager,vcr: ViewContainerRef)
   {
    this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.partnersForm = this.form.group({
      logo:['',[]],
      name:['',[Validators.required]],
      category:['',[Validators.required]]  ,
      url:  ['',[Validators.required]]  
     })   
  }
  async addpartners(value,valid){
    if(valid){
      this.loading=true;
      try{  
  
   const uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);   
   const partnersdata = await  this.afs.collection('partners').add({'logo':uploadedimage['Location'],'name':value.name,'category':value.category,'url':value.url,'createdAt':new Date().toString()});
   const pid = partnersdata.id;
   const id = await this.afs.doc(`/partners/${pid}`).update({ id: pid });

   this.loading = false;
     this.router.navigate(['/partners-list']);
    this.toastr.success('Partners Updated!', 'Success!');
  } 
  catch (error) {
    console.log(error)
    this.toastr.error('Somthing went wrong please try later', 'Oops!');
    this.loading = false;
    this.load=true;
  }}}
  


  changeListner3(event) {
    if (event.target.files && event.target.files[0]) {
      this.image = event.target.files[0]
      var reader = new FileReader();

      reader.onload = (event:any) => {
        this.imgurl3 = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/Partnerss/partners/partners.component.ts